import { loadRecommendationsBlock } from 'blocks/recommendationsBlock/js/loadBlk';
import { RECS_TYPE } from "./utils";

const CLS_HIDE = 'd-none';

/**
 * Get smartRecs (product codes) from epiRecommendations.track to generate recommendation products
 * @param {element} $recsBlock - If not supplied, it will search all "RecommendationsBlock"
 * @param {function} succesCB - Success callback
 * @param {string} recId - Recommendation ID coming from product item (on Quick buy click)
 */
export function getEpiRecommendations($recsBlock, succesCB, recId) {
	if (!$recsBlock) {
		$recsBlock = $(`[data-blk="RecommendationsBlock"]`);
	}

	if ($recsBlock.length === 0) return;

	// dummy sample from the epi tracking factory. Uncomment this block for local testing
	//
	// no recs sample
	// let dummySmartRecs = `{"session":{"session":"3513068300|3eqimFiAuxYfNvgY_klgp9FIIQHNSrs3mZKOx5NR1ME","cuid":"61049406500|4lijewQGwsZR8pma2O2ALAXvdn6C-nzkVMdIbZdSpBI"},"errors":null,"smartRecs":[{"widget":"productAlternativesWidget","alias":"","position":"productAlternativesWidget","recs":[]},{"widget":"productCrossSellsWidget","alias":"","position":"productCrossSellsWidget","recs":[{"lang":"en","refCode":"A_1089896","id":50163657250,"attributes":null},{"lang":"en","refCode":"A_1092480","id":50163657300,"attributes":null},{"lang":"en","refCode":"A_1092362","id":50163657350,"attributes":null},{"lang":"en","refCode":"A_1092364","id":50163657400,"attributes":null},{"lang":"en","refCode":"A_1088233","id":50163657450,"attributes":null},{"lang":"en","refCode":"A_1089890","id":50163657500,"attributes":null},{"lang":"en","refCode":"A_1092363","id":50163657550,"attributes":null},{"lang":"en","refCode":"A_1085477","id":50163657600,"attributes":null},{"lang":"en","refCode":"A_1091567","id":50163657650,"attributes":null},{"lang":"en","refCode":"A_1092361","id":50163657700,"attributes":null}]}],"pageTrackingId":"5950746550|p0xzQmt6vGnDTeAZH3_GLQ","status":"OK"}`;
	// error sample
	// let dummySmartRecs = `{"session":{"session":"3513068300|3eqimFiAuxYfNvgY_klgp9FIIQHNSrs3mZKOx5NR1ME","cuid":"61049406500|4lijewQGwsZR8pma2O2ALAXvdn6C-nzkVMdIbZdSpBI"},"errors":"404","smartRecs":[],"pageTrackingId":"5950746550|p0xzQmt6vGnDTeAZH3_GLQ","status":"Bad Request"}`;

	// let dummySmartRecs = `{"session":{"session":"3513068300|3eqimFiAuxYfNvgY_klgp9FIIQHNSrs3mZKOx5NR1ME","cuid":"61049406500|4lijewQGwsZR8pma2O2ALAXvdn6C-nzkVMdIbZdSpBI"},"errors":null,"smartRecs":[{"widget":"productAlternativesWidget","alias":"","position":"productAlternativesWidget","recs":[{"lang":"en","refCode":"A_1041630_00","id":50163657150,"attributes":null}]},{"widget":"productCrossSellsWidget","alias":"","position":"productCrossSellsWidget","recs":[{"lang":"en","refCode":"A_1091567","id":50163657650,"attributes":null}]},{"widget":"basketWidget","alias":"","position":"basketWidget","recs":[{"lang":"en","refCode":"A_1053870_00","id":50163657200,"attributes":null}]},{"widget":"homeWidget","alias":"","position":"homeWidget","recs":[{"lang":"en","refCode":"A_8146455_00","id":50163656750,"attributes":null}]}],"pageTrackingId":"5950746550|p0xzQmt6vGnDTeAZH3_GLQ","status":"OK"}`;
	// if (typeof dummySmartRecs === 'string') {
	// 	dummySmartRecs = JSON.parse(dummySmartRecs);

	// 	if (!dummySmartRecs || dummySmartRecs.errors) {
	// 		$recsBlock.addClass(CLS_HIDE);
	// 		return;
	// 	}

	// 	if (dummySmartRecs.smartRecs && dummySmartRecs.smartRecs.length > 0) {
	// 		setDataProducts(dummySmartRecs.smartRecs, $recsBlock);
	// 		initRecommendationsBlock();
	// 		if (succesCB) succesCB();
	// 		return;
	// 	}
	// }
	//
	// End of dummy sample

	if (typeof TrackingDataFactory === 'undefined') {
		$recsBlock.addClass(CLS_HIDE);
		return;
	}

	let packageTrackingData = '';
	let $firstRecsBlock = $($recsBlock[0]);
	let recommendationsType = $firstRecsBlock.data('recommendationsType');

	switch (recommendationsType) {
		case RECS_TYPE.HOME:
			packageTrackingData = TrackingDataFactory.createHomeTrackingData();
			break;

		case RECS_TYPE.BASKET:
			packageTrackingData = TrackingDataFactory.createBasketTrackingData();
			break;

		case RECS_TYPE.SEARCH:
			let urlParams = new URLSearchParams(window.location.search);
			let term = urlParams.get('s');
			let productCodes = $('[data-wg="ProductItem"]').map((i, item) => item.getAttribute('data-item-id'));
			packageTrackingData = TrackingDataFactory.createSearchResultTrackingData(term, productCodes);
			break;
	
		case RECS_TYPE.ADD_TO_CART:
			packageTrackingData = TrackingDataFactory._createTrackingDataBase('other');
			packageTrackingData.customAttributes['pageType'] = 'Add To Cart';
			break;
		
		case RECS_TYPE.MINI_CART:
			packageTrackingData = TrackingDataFactory._createTrackingDataBase('other');
			packageTrackingData.customAttributes['pageType'] = 'Mini Cart';
			break;

		default:
			packageTrackingData = TrackingDataFactory.createProductTrackingData($firstRecsBlock.data('productcode'), $firstRecsBlock.data('productname'));
			break;
	}

	// https://world.episerver.com/documentation/developer-guides/commerce/personalization/recommendations/client-side-api-integration/
	if (packageTrackingData && epiRecommendations) {
		let recommendationId = '';

		if (recommendationsType === RECS_TYPE.BASKET) {
			recommendationId = recId || '';
		} else {
			let urlParams = new URLSearchParams(window.location.search);
			recommendationId = urlParams.get('recommendationId') || '';
		}

		packageTrackingData['skipRecommendations'] = false;
		if (recommendationId) {
			packageTrackingData['recommendationId'] = recommendationId;
		}

		epiRecommendations.track(
			packageTrackingData,
			$('.endpoints-definition').data('sitename'),
			$('.endpoints-definition').data('channel'),
			(returnedData) => {
				if (!returnedData || returnedData.errors) {
					$recsBlock.addClass(CLS_HIDE);
					return;
				}

				let data = returnedData;
				if (typeof data === 'string') {
					data = JSON.parse(data);
				}

				// check if there are recs value return, if not don't call "getProducts" api
				if (data.smartRecs && data.smartRecs.length > 0) {
					// set products first then do API call
					setDataProducts(data.smartRecs, $recsBlock);
					initRecommendationsBlock();

					if (succesCB) succesCB();
				}
			}
		);
	}
}

// set data-products coming from epiRecommendations
function setDataProducts (smartRecs, $recsBlock) {
	$recsBlock.each((i, blk) => {
		let $blk = $(blk);
		let recsType = $blk.data('recommendationsType');
		let currentRecs = smartRecs.find(o => o.widget === recsType);

		if (currentRecs) {
			$blk.data('recs', currentRecs.recs);
			let products = currentRecs.recs.map((item) => item.refCode);

			if (products.length === 0) {
				$blk.addClass(CLS_HIDE);
			} else {
				$blk.data('products', products.join(','));
			}
		} else {
			$blk.addClass(CLS_HIDE);
		}
	});
}

function initRecommendationsBlock() {
	// Start loadRecommendationsBlock script
	loadRecommendationsBlock(document.body, true).then((blkAll) => {
		(blkAll && blkAll.length > 0) ? blkAll.forEach((blk) => {
			blk.init();
		}) : '';
	}).catch((error) => `${error} An error occurred while loading loadRecommendationsBlock script`);
	// End loadRecommendationsBlock script
}



// WEBPACK FOOTER //
// ./epiTrack.js